<child-header title="Confirm Pending Total" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>
  <loading-screen *ngIf="!loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
  (currentLoadingStatus)="onLoading($event)">
  </loading-screen>
  <p>
    Your new Total is &nbsp;<span class="color-red bold">{{data.totalPriceChange |
      currency:'AUD':'symbol-narrow':'.2-2'}}</span><span>/mth</span>
  </p>
  <p>
    Once you have confirmed the order total noted above this request will be sent to WatchGuard for verification and
    actioning. This portal will be automatically updated once WatchGuard have confirmed your requested changes are
    live in their systems. Until this confirmation is received, your WatchGuard subscriptions will remain in
    their
    current state.
    If you have any questions regarding this process or the changes you are applying, please contact your Dicker
    Data
    representative.
  </p>

  <!--  <mat-form-field>
    <input matInput numberLettersOnly type="text" maxlength="30" class="poReference" [(ngModel)]="poReference" placeholder="PO REFERENCE (Must be unique)" (input)="commonService.subscription_customer_ref_validation($event)" />
  </mat-form-field> -->

  <div [formGroup]="userFormGroup">
    <mat-form-field>
      <input matInput numberLettersOnly type="text" maxlength="20" formControlName="poReference" class="poReference"
        [(ngModel)]="poReference" placeholder="PO REFERENCE (Must be unique)"
        (input)="commonService.subscription_customer_ref_validation($event, 'wgsPORef')" />
    </mat-form-field>
   <!--  <div>
      <p>Please enter the shipping address to send this device</p>
    </div> -->
    <div>
      <p>Please enter the shipping address to send this device</p>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsCompanyNameValidate" formControlName="CompanyName" [(ngModel)]="CompanyName"
          placeholder="CompanyName" required>
      </mat-form-field>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsAttnRefValidate" formControlName="AttentionRef" [(ngModel)]="AttentionRef"
          placeholder="Attn/Ref" required>
      </mat-form-field>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsEmailValidate" formControlName="Email" [(ngModel)]="Email" placeholder="Email"
          required>
      </mat-form-field>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsAddressLine1Validate" formControlName="AddressLine1" [(ngModel)]="AddressLine1"
          placeholder="Address Line 1" required>
      </mat-form-field>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsAddressLine2Validate" formControlName="AddressLine2" [(ngModel)]="AddressLine2"
          placeholder="Address Line 2">
      </mat-form-field>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsAddressLine3Validate" formControlName="AddressLine3" [(ngModel)]="AddressLine3"
          placeholder="Address Line 3">
      </mat-form-field>
      <!--  </div>
      <div class="userinfo col-md-6"> -->
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsCityValidate" (input)="onInputSub($event)"
          #myAutocompleteTriggerSub="matAutocompleteTrigger" [matAutocomplete]="autoSuburb" [(ngModel)]="City"
          formControlName="City" placeholder="SUBURB" (keydown.Tab)="chooseAutoCompletSuburb($event)"
          (suburb)="startFilterSub($event)" required>
        <mat-autocomplete #autoSuburb="matAutocomplete">
          <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb" (click)="chooseAutoComplete(option)">
            {{option?.suburb+", "+option?.state+", "+option?.postcode}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <ng-select class="customDropdwon wgsStateValidate" [items]="stateList" bindValue="state" bindLabel="state"
        placeholder="State *" [(ngModel)]="State" formControlName="State"></ng-select>
      <mat-form-field [floatLabel]="'always'">
        <!-- (keyup)="startFilterPostcode()" -->
        <input matInput class="wgsPostCodeValidate" maxlength="4"
          #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)"
          (keypress)="isNumberKey($event)" [(ngModel)]="PostCode" formControlName="PostCode"
          (postcode)="startFilterPostcode($event)" (keydown.Tab)="chooseAutoCompletPostcode($event)"
          [matAutocomplete]="autoPostcode" placeholder="POST CODE" required>
        <mat-autocomplete #autoPostcode="matAutocomplete">
          <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
            (click)="chooseAutoComplete(option)">
            {{option?.suburb+", "+option?.state+", "+option?.postcode}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field [floatLabel]="'always'">
        <input matInput class="wgsPhoneNumberValidate" [(ngModel)]="PhoneNumber" formControlName="PhoneNumber"
          placeholder="Phone Number" required>
      </mat-form-field>
    </div>
    <!-- </div> -->
   
  </div>

</div>
<div mat-dialog-actions>
  <button mat-button class="button button-red button-large continue"
    (click)="continueSaveSubscription()">Continue</button>
</div>